module.exports = __webpack_public_path__ + "static/media/PF_Airdrop-Upgrades.4e5ead28.jpg";